import _ from "lodash";
import { INVENTORY } from "constants/action-types";
import { stringify } from "querystring";
import type { IStore } from "reducers";
import type { Dispatch } from "react-redux";
import type { IFetchOptions } from "types/inventory";
import type { IAction } from "epics/base-epic";
import { getSessionKey } from "helpers/inventory";

export const fetchReplenishments =
    (warehouse: string, skus: string[], options?: IFetchOptions) =>
    (dispatch: Dispatch<{}>, getState: () => IStore) => {
        const { scope, inventory } = getState();

        const sessionKey = getSessionKey(options);
        const sameSession = sessionKey === inventory.replenishments.meta?.sessionKey;
        const useCache = !!options?.session;

        // use cache per session key
        if (useCache && !sameSession) {
            dispatch({ type: INVENTORY.REPLENISHMENTS.UPDATE, payload: { payload: {} } }); // clean up previous session
        }
        const filtered =
            useCache && sameSession ? _.difference(skus, _.keys(inventory.replenishments.payload?.[warehouse])) : skus;

        if (!_.isEmpty(filtered)) {
            dispatch({
                type: INVENTORY.REPLENISHMENTS.FETCH.START,
                payload: {
                    url: `/api/v3.0/warehouse/${warehouse}/skus/replenishments?${stringify(
                        _.omitBy(
                            _.defaults(
                                {
                                    sku_id: filtered,
                                    __company: options?.companyId || scope.viewAs?._id,
                                    __prebook: options?.prebook,
                                    forRef: options?.forRef,
                                    fromRef: options?.fromRef,
                                },
                                { __prebook: false } // fetch only ats replenishments by default
                            ),
                            _.isUndefined
                        )
                    )}`,
                },
                meta: {
                    ...options,
                    sessionKey,
                    session: options?.session,
                    forRef: options?.forRef,
                    fromRef: options?.fromRef,
                },
            });
        }
    };

/**
 * Gets action to invoke warehouses fetching
 * @param context - id for which warehouses availability is requested (product_id, order_id, etc.)
 * @param [options]
 * @param [options.skuIds] - array of sku ids
 * @param [options.companyId] - company id
 * @returns {Object}
 */
export const fetchWarehouses = (
    context: string,
    options: { skuIds?: string[]; companyId?: string } = {},
    meta?: Record<string, any>
): IAction<{ skuIds?: string[]; companyId?: string; context: string }> => ({
    payload: { ...options, context },
    type: INVENTORY.WAREHOUSES.FETCH.START,
    meta,
});
